/**
 * Parse a date-only string (YYYY-MM-DD) into a Date that is stable across timezones.
 *
 * Why: `new Date('YYYY-MM-DD')` is interpreted as UTC midnight by JS, which can
 * shift the local calendar day (e.g. Monday becomes Sunday night in -03:00).
 *
 * Strategy: anchor at local noon to avoid crossing day boundaries.
 */
export function parseDateOnly(dateStr: string | null | undefined): Date | null {
  if (!dateStr) return null;
  // Keep as local calendar date regardless of user timezone.
  const d = new Date(`${dateStr}T12:00:00`);
  return Number.isNaN(d.getTime()) ? null : d;
}
